module.exports = __webpack_public_path__ + "img/day2.1f455c90.jpg";